export default {
footer: {
    ageRestriction: "Nuestra plataforma es solo para usuarios mayores de 18 años. El juego puede ser adictivo. Por favor, juegue de manera responsable y solo por entretenimiento. Para obtener más información, visite nuestra página de Juego Responsable.",
    followUs: "SÍGUENOS",
    company: "EMPRESA",
    legal: "LEGAL",
    support: "SOPORTE",
    gameProviders: "PROVEEDORES DE JUEGOS",
    copyright: "Copyright © 2019-2026 LOGO. Todos los derechos reservados.",
	documents: "Documentos",
  }
}
